import type { SavedReport, SetSharedSavedReportPayload } from '../interfaces';
import type { ApiResponse } from '@Types';
import { API } from '@Providers';

export default async function ({ _id, shareable }: SetSharedSavedReportPayload) {
  const endpoint = `/api/shelter/saved-reports/${_id}/share`;

  return API({ endpoint, method: 'post', payload: { shareable } }) as Promise<ApiResponse<SavedReport>>;
}
